import { render, staticRenderFns } from "./alert-message.vue?vue&type=template&id=62d3c10f&scoped=true&"
import script from "./alert-message.vue?vue&type=script&lang=js&"
export * from "./alert-message.vue?vue&type=script&lang=js&"
import style0 from "./alert-message.vue?vue&type=style&index=0&id=62d3c10f&scoped=true&lang=scss&"
import style1 from "./alert-message.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d3c10f",
  null
  
)

export default component.exports